import styled from "styled-components";

import { colors } from "global/globalStyle";

export interface ICircleCSS {
  colorIcon?: string;
  widthHeightIcon?: number;
  widthHeightBorder?: number;
  borderColor?: string;
  backgroundColor?: string;
}

export const CircleIconDiv = styled.div<ICircleCSS>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) =>
    props.widthHeightBorder ? props.widthHeightBorder + "px" : "28px"};
  height: ${(props) =>
    props.widthHeightBorder ? props.widthHeightBorder + "px" : "28px"};
  border-radius: 50%;
  border: ${(props) =>
    props.borderColor
      ? `2px solid ${props.borderColor}`
      : `2px solid ${colors.primary_default}`};
  background-color: ${(props) => props.backgroundColor ?? "none"};

  .MuiSvgIcon-root {
    color: ${(props) => props.colorIcon ?? colors.primary_default};
    height: ${(props) =>
      props.widthHeightIcon ? props.widthHeightIcon + "px" : "16px"};
    width: ${(props) =>
      props.widthHeightIcon ? props.widthHeightIcon + "px" : "16px"};
  }
`;
